"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameToId = void 0;
/**
 * Transforms an HTML input name property to a valid HTML id.
 * @param name - An HTML input `name` prop.
 * @returns A valid HTML `id` prop.
 */
function nameToId(name) {
    return name === null || name === void 0 ? void 0 : name.replace(".", "_");
}
exports.nameToId = nameToId;
//# sourceMappingURL=nameToId.js.map